import { QueryKey } from '@tanstack/react-query';

import { UserSettingsRetrieve } from '@playq/octopus2-auth';
import { GenericFailure } from '@playq/services-shared';

import { useEitherQuery, IUseQueryOptionsExtended } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { usersServiceProfile } from './useRetrieveProfile';

export const retrieveProfileSettingsKeys: QueryKey = usersServiceProfile.concat('settings');

export const useRetrieveProfileSettings = (
  options?: IUseQueryOptionsExtended<UserSettingsRetrieve | undefined, GenericFailure | Error>
) => {
  const res = useEitherQuery(retrieveProfileSettingsKeys, () => services2.userProfileService.retrieveSettings(), {
    ...options,
  });

  return {
    ...res,
    settings: res.data?.settings,
  };
};
